
import { Link } from 'react-router-dom';

export default function ChairLineupCTA() {
  return (
    <section
      className="relative py-20 sm:py-28 md:py-36 overflow-hidden"
      aria-labelledby="cta-heading"
    >
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d7391a4a1dd45b1060a3989c4412ba7a.jpg"
          alt="MeVER Chair 体験スペース"
          className="w-full h-full object-cover object-top"
          loading="lazy"
          width="1920"
          height="800"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/60 to-black/70"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
        <h2
          id="cta-heading"
          className="text-3xl sm:text-4xl md:text-5xl font-extralight text-white mb-4 sm:mb-6 tracking-[0.08em]"
        >
          まずは、座ってみてください
        </h2>
        <p className="text-sm sm:text-base md:text-lg font-extralight text-white/60 mb-10 sm:mb-14 max-w-2xl mx-auto leading-relaxed tracking-wide">
          新宿のショールームで全モデルをお試しいただけます。
          <br className="hidden sm:block" />
          オンラインではわからない座り心地を、ぜひ体感してください。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-5 mb-10 sm:mb-14">
          <a
            href="https://appointment.mever.design/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-10 sm:px-12 py-4 sm:py-5 bg-white text-black text-sm sm:text-base font-light tracking-[0.1em] hover:bg-white/90 transition-all whitespace-nowrap rounded-md cursor-pointer"
          >
            <i className="ri-calendar-check-line text-base" aria-hidden="true"></i>
            体験予約する
          </a>
          <Link
            to="/coworking"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-10 sm:px-12 py-4 sm:py-5 border border-white/30 text-white text-sm sm:text-base font-light tracking-[0.1em] hover:bg-white/10 transition-all whitespace-nowrap rounded-md cursor-pointer"
          >
            コワーキング体験
            <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </Link>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10 mb-14 sm:mb-16">
          <div className="flex items-center gap-2 text-white/40">
            <i className="ri-truck-line text-lg" aria-hidden="true"></i>
            <span className="text-xs sm:text-sm font-extralight tracking-wide">
              全国送料無料
            </span>
          </div>
          <div className="flex items-center gap-2 text-white/40">
            <i className="ri-shield-check-line text-lg" aria-hidden="true"></i>
            <span className="text-xs sm:text-sm font-extralight tracking-wide">
              最大5年保証
            </span>
          </div>
          <div className="flex items-center gap-2 text-white/40">
            <i className="ri-customer-service-2-line text-lg" aria-hidden="true"></i>
            <span className="text-xs sm:text-sm font-extralight tracking-wide">
              購入後サポート
            </span>
          </div>
        </div>

        {/* Atelier Folio Cross-promotion */}
        <div className="border-t border-white/10 pt-10 sm:pt-12">
          <Link
            to="/atelier-folio"
            className="group inline-flex flex-col sm:flex-row items-center gap-4 sm:gap-6 px-6 sm:px-8 py-5 sm:py-6 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl hover:bg-white/10 hover:border-[#8E7AB5]/30 transition-all cursor-pointer"
          >
            <div className="w-14 h-14 flex items-center justify-center bg-[#8E7AB5]/15 rounded-xl flex-shrink-0">
              <i className="ri-tablet-line text-[#8E7AB5] text-2xl" aria-hidden="true"></i>
            </div>
            <div className="text-center sm:text-left">
              <div className="flex items-center justify-center sm:justify-start gap-2 mb-1">
                <span className="text-white font-medium text-sm sm:text-base">
                  Atelier Folio for iPad
                </span>
                <span className="px-2 py-0.5 bg-emerald-500/20 text-emerald-400 text-[10px] font-medium rounded-full">
                  COMING SOON
                </span>
              </div>
              <p className="text-white/40 text-xs sm:text-sm font-light">
                MeVER Chairと合わせて、最高のクリエイティブ環境を
              </p>
            </div>
            <i
              className="ri-arrow-right-line text-white/30 group-hover:text-[#8E7AB5] group-hover:translate-x-1 transition-all text-lg hidden sm:block"
              aria-hidden="true"
            ></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
